import React from 'react'
import { BiCopyright } from 'react-icons/bi'
const Footer = () => {
    return (
        <div className='footer'>
            <h1>Arpit Keep <BiCopyright /> All Right Reserved</h1>
        </div>
    )
}

export default Footer
